import React from 'react'
import ErrorIcon from '../../assets/icons/error.svg'
import { cn } from '../../utils/utils';
type Props = {
    smallView?: boolean;
}

function ErrorSection({smallView=false}: Props) {
  return (
    <div className={cn(`flex flex-col h-full w-full items-center justify-center text-primary text-center flex-grow pb-[25vh] mobile:pb-[35vh] `,smallView && 'pb-0 mobile:pb-0')}>
        <img src={ErrorIcon} alt=""  />
        <h2 className='pt-2'>something went wrong</h2>
        <p className='font-bold  text-secondary'>check your internet connection or call support team</p>
    </div>
  )
}

export default ErrorSection